import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const IdCLienteSIREFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
    return (
        <Form.Group>
            <Form.Label text='ID Cliente' htmlFor='input-idCLienteSIRE' md={4} alignRightAt='md' />
            <Col md={8}>
                <Field name='idCLienteSIRE'>
                    {({ field }) => (
                        <Form.InputText
                            {...field}
                            isInvalid={iTouched && iError}
                            disabled={fIsSubmitting}
                            id='input-idCLienteSIRE'
                        />
                    )}
                </Field>
                {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
            </Col>
        </Form.Group>
    )
}

export default React.memo(IdCLienteSIREFormGroup)
